"use client";

import React, { createContext, useState } from "react";

const VideoIntroContext = createContext<any>(false);

/**
 * A React context provider component to track if the YEX intro video page has been
 * displayed.
 *
 * @remarks
 * This context provider component sets a boolean to true if the video intro page has
 * been displayed.
 *
 * @param param0
 * @returns - The VideoIntroContext provider component in JSX.
 */
export function VideoIntroProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [videoIntro, setVideoIntro] = useState(false);

  return (
    <VideoIntroContext.Provider value={{ videoIntro, setVideoIntro }}>
      {children}
    </VideoIntroContext.Provider>
  );
}

export default VideoIntroContext;
